const IMAGE_BASE_PATH = '/images/products/';

const animal_products = [
  {
    id: 'd1ab965f',
    name: '고양이용 초록입홍합 트릿',
    amount: '50g/1.76oz',
    price: '18,000원',
    categories: [1],
    highlight: `고양이를 위한 뉴질랜드 초록입홍합 간식은 다음과 같은 특징을 가지고 있습니다:

    - 풍부한 오메가-3, 글루코사민, 콘드로이틴: 관절 건강에 필수적인 영양소들이 가득합니다.
    - 지속 가능한 생산 및 동결 건조: 뉴질랜드에서 지속 가능한 방식으로 양식되었으며, 영양 손실 없이 동결 건조했습니다.
    - 깔끔하고 편리한 보관: 급여 시 번거로움이 없으며, 냉장 보관이 필요 없습니다.
    - 100% 천연 무첨가: 어떠한 첨가물도 없이 순수한 자연 재료로만 만들어졌습니다.`,
    description: `초록입홍합은 건강상의 이점으로 매우 높이 평가받고 있습니다. 뉴질랜드가 원산지인 이 홍합은 오메가-3 지방산, 특히 심장 건강과 뇌 기능에 필수적인 EPA와 DHA의 풍부한 공급원입니다.

    초록입홍합의 천연 항염증 특성은 관절 건강을 돕고 관절 통증을 완화하는 것으로 잘 알려져 있습니다. 또한 건강한 연골과 관절 유연성을 유지하는 데 유익한 콘드로이틴 설페이트와 글루코사민이 함유되어 있습니다.
    초록입홍합은 단백질, 비타민(B12, E, C), 미네랄(아연, 셀레늄), 아미노산과 같은 독특하고 다양한 필수 영양소를 제공합니다. 초록입홍합을 섭취하는 것은 고양이의 전반적인 건강 증진에 도움을 주어 식단에 귀중한 보탬이 될 것입니다.`,
    ingredient: `100% 뉴질랜드산 초록입홍합
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 고양이의 주식 대용이 아닙니다. 간식은 고양이의 일일 총 칼로리 섭취량의 10%를 넘지 않도록 급여해 주세요. 물고기 혹은 어패류에 알러지가 있을 경우 급여하지 마십시오. 간식을 줄 땐 항상 보호관찰이 필요합니다.`,
    image: 'Nutreats_Cat_GreenLippedMussel.png',
  },
  {
    id: '4cf19089',
    name: '고양이용 소 심장 트릿',
    amount: '50g/1.76oz',
    price: '18,000원',
    categories: [1],
    highlight: `고양이에게 뉴질랜드 최상급 소 심장 간식을 급여하면 다음과 같은 이점을 누릴 수 있습니다:

    고품질 단백질의 보고: 근육 발달과 전반적인 건강 유지에 필수적인 고품질 단백질이 풍부합니다.
    필수 비타민과 미네랄 함유: 고양이의 심장 건강과 시력에 중요한 타우린을 비롯한 필수 비타민과 미네랄이 가득합니다.
    건강한 조직 유지 지원: 고양이의 건강한 신체 조직 유지에 도움을 줍니다.
    최대 영양 보존 및 편리함: 영양을 최대한 보존하기 위해 동결 건조되었으며, 편리하게 보관할 수 있는 재밀봉 포장으로 제공됩니다.

    [중요 안내] 이 천연 간식은 고양이의 주식 대용이 아닙니다. 간식은 고양이의 일일 총 칼로리 섭취량의 10%를 넘지 않도록 급여해 주세요.`,
    description: `
    고양이에게 소 심장을 급여하는 것은 단백질, 철분, 비타민의 천연 공급원을 제공하는 것과 같습니다. 소 심장은 고품질 단백질이 풍부하여 근육 발달과 전반적인 건강 증진에 도움을 줍니다.
    
    50g 간식 한 팩은 생고기 250g과 맞먹는 풍부한 영양을 제공하며, 냉장 보관이 필요 없어 더욱 편리합니다. 고양이는 자연 그대로의 맛에 푹 빠져들 것이고, 보호자님께서는 풍부한 미량 영양소로부터 얻는 기능적인 건강상의 이점에 만족하실 겁니다.
    특히 고양이의 심장 건강과 시력에 중요한 타우린을 비롯한 필수 비타민과 미네랄을 제공합니다. 또한 소 심장에는 다양한 비타민 B군과 철분도 함유되어 있어, 균형 잡히고 영양가 있는 식단에 기여합니다. 소 심장은 균형 잡힌 식단의 일부로 제공되어야 하며, 고양이의 일일 섭취량의 10%를 초과하지 않도록 하는 것이 중요합니다.`,
    ingredient: `100% 뉴질랜드산 소 심장
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 고양이의 주식 대용이 아닙니다. 간식은 고양이의 일일 총 칼로리 섭취량의 10%를 넘지 않도록 급여해 주세요.모든 간식이 그러하듯, 목에 걸릴 가능성이 존재하니 간식을 줄 땐 항상 보호관찰이 필요합니다.`,
    image: 'Nutreats_Cat_NZBeefHeart.png',
  },
  {
    id: '1603e641',
    name: '고양이용 사슴고기 트릿',
    amount: '50g/1.76oz',
    price: '18,000원',
    categories: [1],
    highlight: `뉴질랜드 방목 사슴고기 간식을 고양이에게 급여하면 다음과 같은 이점을 얻을 수 있습니다:

    저지방 고단백: 과도한 지방 걱정 없이 근육 성장과 회복을 지원하는 저지방 단백질원입니다.
    알레르기/민감성 완화: 알레르기나 식품 민감성을 유발할 가능성이 낮아 안심하고 급여할 수 있습니다.
    영양 덩어리: 비타민 B군(B6, B12), 미네랄(아연, 인) 등 필수 영양소가 풍부하게 함유되어 있습니다.
    오메가-3 지방산: 건강한 피부와 심혈관 건강 증진에 도움을 주는 오메가-3 지방산이 포함되어 있습니다.
    체중 관리 지원: 낮은 콜레스테롤 함량으로 체중 관리에 도움을 주며, 건강한 신체 균형 유지에 기여합니다.`,
    description: `
    뉴질랜드의 비옥한 초원에서 자유롭게 자란 방목 사슴고기 그대로를, 영양을 최대한 보존하기 위해 동결 건조하여 재밀봉 가능한 포장에 담았습니다. 이것이 전부입니다. 오직 순수함 그 자체죠! 인공적인 성분, 곡물, 첨가물, 색소, 방부제는 전혀 들어있지 않습니다.
    50g 간식 한 팩은 생고기 250g과 맞먹는 풍부한 영양을 제공하며, 냉장 보관이 필요 없어 더욱 편리합니다. 고양이는 자연 그대로의 맛에 푹 빠져들 것이고, 보호자님께서는 풍부한 미량 영양소로부터 얻는 기능적인 건강상의 이점에 만족하실 겁니다. 모든 크기와 연령의 고양이를 위한 100% 천연 저지방 단백질 간식입니다.

    사슴고기 간식은 고양이의 건강에 수많은 이점을 제공합니다. 저지방 단백질원인 사슴고기는 건강한 근육 발달과 유지, 그리고 전반적인 활력 증진에 도움을 줍니다.
    사슴고기는 종종 저자극성 식품으로 간주되어, 음식 민감성을 가진 고양이에게 훌륭한 선택지가 됩니다. 또한 비타민 B6, B12와 같은 비타민 B군, 그리고 아연, 인과 같은 미네랄이 풍부하여 신진대사 과정을 돕고 면역 체계를 지원하며, 건강하고 윤기나는 피부와 털을 유지하는 데 기여합니다.
    더불어 사슴고기에는 오메가-3 지방산이 함유되어 있어 심장 건강을 돕고 자연스러운 인지 기능 향상에도 이로울 수 있습니다. 낮은 지방 함량은 반려동물의 체중 관리가 필요한 경우에도 적합한 간식이 될 수 있습니다.
    `,
    ingredient: `100% 뉴질랜드산 사슴고기 
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 고양이의 주식 대용이 아닙니다. 간식은 고양이의 일일 총 칼로리 섭취량의 10%를 넘지 않도록 급여해 주세요. 모든 간식과 마찬가지로, 고양이가 급하게 먹다가 목에 걸리는 것을 방지하기 위해 급여 시에는 항상 옆에서 지켜봐 주시기 바랍니다.`,
    image: 'Nutreats_Cat_NZFreeRangeVenison.png',
  },
  {
    id: '29c89cef',
    categories: [2],
    name: '강아지용 소 심장 트릿',
    amount: '50g/1.76oz',
    price: '18,000원',
    highlight: `반려견에게 소 심장 간식을 급여하면 다음과 같은 다양한 이점을 누릴 수 있습니다:

    고품질 단백질의 보고: 근육 발달과 전반적인 건강 유지에 필수적인 고품질 단백질이 풍부합니다.
    필수 비타민과 미네랄 함유: 특히 반려견의 심장 건강과 시력에 중요한 타우린을 비롯한 필수 비타민과 미네랄이 가득합니다.
    건강한 조직 유지 지원: 반려견의 건강한 신체 조직 유지에 도움을 줍니다.
    최대 영양 보존 및 편리함: 영양을 최대한 보존하기 위해 동결 건조되었으며, 편리하게 보관할 수 있는 재밀봉 포장으로 제공됩니다.`,
    description: `
    청정한 뉴질랜드의 비옥한 초원에서 온 신선한 소 심장 그대로를, 영양을 최대한 보존하기 위해 동결 건조하여 재밀봉 가능한 포장에 담았습니다. 이것이 전부입니다. 오직 순수함 그 자체죠! 인공 성분, 곡물, 첨가물, 색소, 방부제는 전혀 들어있지 않습니다.
    50g 간식 한 팩은 생고기 250g과 맞먹는 풍부한 영양을 제공하며, 냉장 보관이 필요 없어 더욱 편리합니다. 반려견은 자연 그대로의 맛에 푹 빠져들 것이고, 보호자님께서는 풍부한 미량 영양소로부터 얻는 기능적인 건강상의 이점에 만족하실 겁니다.

    뉴질랜드 청정 자연에서 온 소 심장은 단백질, 철분, 비타민의 천연 보고입니다. 소 심장은 고품질 단백질이 풍부하여 반려견의 튼튼한 근육 발달과 전반적인 활력 유지에 도움을 줍니다.
    특히 반려견의 심장 건강과 선명한 시력을 위한 핵심 영양소인 타우린을 비롯해 다양한 비타민 B군과 철분까지 함유하고 있어, 균형 잡힌 영양 섭취에 크게 기여합니다. 소 심장 간식은 반려견의 균형 잡힌 식단의 일부로 제공되어야 하며, 일일 섭취량의 10%를 초과하지 않도록 주의해 주세요.
    `,
    ingredient: `100% 뉴질랜드산 소 심장 
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 반려견의 주식 대용이 아닙니다. 간식은 반려견의 일일 총 칼로리 섭취량의 10%를 넘지 않도록 급여해 주세요. 급여 시에는 항상 옆에서 지켜봐 주시기 바랍니다.`,
    image: 'Nutreats_Dog_BeefHeart.png',
  },
  {
    id: 'beb22ff7',
    categories: [2],
    name: '강아지를 위한 소 심장 트릿',
    amount: '50g/1.76oz',
    price: '18,000원',
    highlight: `뉴질랜드 방목 사슴고기 간식을 반려견에게 급여하면 다음과 같은 이점을 얻을 수 있습니다:

    저지방 고단백: 과도한 지방 걱정 없이 근육 성장과 회복을 지원하는 저지방 단백질원입니다.
    알레르기/민감성 완화: 알레르기나 식품 민감성을 유발할 가능성이 낮아 안심하고 급여할 수 있습니다.
    영양 덩어리: 비타민 B군(B6, B12), 미네랄(아연, 인) 등 필수 영양소가 풍부하게 함유되어 있습니다.
    오메가-3 지방산: 건강한 피부와 심혈관 건강 증진에 도움을 주는 오메가-3 지방산이 포함되어 있습니다.
    체중 관리 지원: 낮은 콜레스테롤 함량으로 체중 관리에 도움을 주며, 건강한 신체 균형 유지에 기여합니다.`,
    description: `
    뉴질랜드의 비옥한 초원에서 자유롭게 자란 방목 사슴고기 그대로를, 영양을 최대한 보존하기 위해 동결 건조하여 재밀봉 가능한 포장에 담았습니다. 이것이 전부입니다. 오직 순수함 그 자체죠! 인공적인 성분, 곡물, 첨가물, 색소, 방부제는 전혀 들어있지 않습니다.
    50g 간식 한 팩은 생고기 250g과 맞먹는 풍부한 영양을 제공하며, 냉장 보관이 필요 없어 더욱 편리합니다. 반려견은 자연 그대로의 맛에 푹 빠져들 것이고, 보호자님께서는 풍부한 미량 영양소로부터 얻는 기능적인 건강상의 이점에 만족하실 겁니다.
    모든 크기와 연령의 반려견을 위한 100% 천연 저지방 단백질 간식입니다.

    사슴고기 간식은 반려견의 건강에 수많은 이점을 제공합니다. 저지방 단백질원인 사슴고기는 건강한 근육 발달과 유지, 그리고 전반적인 활력 증진에 도움을 줍니다.
    사슴고기는 종종 저자극성 식품으로 간주되어, 음식 민감성을 가진 반려견에게 훌륭한 선택지가 됩니다. 또한 비타민 B6, B12와 같은 비타민 B군, 그리고 아연, 인과 같은 미네랄이 풍부하여 신진대사 과정을 돕고 면역 체계를 지원하며, 건강하고 윤기나는 피부와 털을 유지하는 데 기여합니다.
    더불어 사슴고기에는 오메가-3 지방산이 함유되어 있어 심장 건강을 돕고 자연스러운 인지 기능 향상에도 이로울 수 있습니다. 낮은 지방 함량은 체중 관리가 필요한 반려견에게도 적합한 간식이 될 수 있습니다.
    `,
    ingredient: `100% 뉴질랜드산 사슴고기
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 반려견의 주식 대용이 아닙니다. 간식으로만 사용하세요. 또한 사람이 먹는 용도가 아닙니다. 급여 시에는 항상 옆에서 지켜봐 주시기 바랍니다.`,
    image: 'Nutreats_Dog_FreeRangeVenison.png',
  },
  {
    id: 'a6d62eff',
    name: '강아지를 위한 초록입홍합 트릿',
    categories: [2],
    amount: '50g/1.76oz',
    price: '18,000원',
    highlight: `뉴질랜드 초록입홍합 강아지 간식은:
    - 오메가-3, 글루코사민, 콘드로이틴이 풍부합니다.
    - 뉴질랜드에서 지속 가능하게 양식되고 동결 건조되었습니다.
    - 청소가 필요 없고 냉장 보관이 필요 없습니다.
    - 100% 천연 성분으로 첨가물 없이 제조되었습니다.`,
    description: `
    뉴질랜드의 청정한 바다에서 직접 채취한 순수한 초록입홍합! 영양을 최대한 보존하기 위해 동결 건조하였으며, 재밀봉 가능한 포장에 담겨 있습니다. 이것이 전부입니다. 오직 순수함 그 자체죠. 인공적인 성분, 곡물, 첨가물, 색소, 방부제는 전혀 들어있지 않습니다.
    50g 트릿 한 팩은 생 홍합 250g에 해당하는 풍부한 영양을 제공하며, 냉장 보관이 필요 없어 더욱 편리합니다. 반려견은 이 자연 그대로의 맛을 무척 좋아할 것이며, 보호자님께서는 풍부한 미량 영양소로부터 얻는 기능적인 건강상의 이점에 만족하실 겁니다.

    수많은 건강상의 이점으로 이미 명성이 높은 초록입홍합은 반려견의 건강 관리에 빼놓을 수 없는 귀한 존재입니다. 뉴질랜드 청정 해역에서 자란 이 홍합은 건강한 심장과 관절 기능, 그리고 인지 능력 향상에 필수적인 오메가-3 지방산(특히 EPA와 DHA)이 풍부하게 함유되어 있습니다.
    특히 관절 건강을 돕고 관절 불편함을 완화하는 데 탁월한 것으로 잘 알려져 있습니다. 주목할 점은 연골을 튼튼하게 유지하고 유연한 관절 움직임을 돕는 콘드로이틴 설페이트와 글루코사민이 다량 함유되어 있다는 것입니다.
    초록입홍합은 이 외에도 단백질, 비타민(B12, E, C), 미네랄(아연, 셀레늄), 아미노산을 포함한 다양한 필수 영양소들을 탁월하게 제공합니다. 반려견의 식단에 초록입홍합을 더하는 것은 전반적인 활력을 증진시키고, 반려동물의 영양 관리에 매우 귀중한 보탬이 될 것입니다.
    `,
    ingredient: `100% 뉴질랜드산 초록입홍합
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 반려견의 주식 대용이 아닙니다. 또한 반려견이 생선 혹은 갑각류에 알레르기가 있으면 먹이지 마십시오. 급여 시에는 항상 옆에서 지켜봐 주시기 바랍니다.`,
    image: 'Nutreats_Dog_GreenLippedMussel.png',
  },
  {
    id: 'aec24c3a',
    name: '강아지를 위한 양 간 트릿',
    categories: [2],
    amount: '50g/1.76oz',
    price: '18,000원',
    highlight: `반려견을 위한 뉴질랜드 양 간 간식의 이점은 다음과 같습니다:

    - 고단백 저지방: 반려견이 무척 좋아할 고단백 저지방 간식입니다.
    - 풍부한 영양소: 오메가-3, 글루코사민, 콘드로이틴이 풍부하게 함유되어 있습니다.
    - 지속 가능한 생산: 뉴질랜드에서 지속 가능한 방식으로 사육된 양의 간을 동결 건조했습니다.
    - 간편한 보관: 깔끔하게 급여할 수 있으며, 냉장 보관이 필요 없습니다.
    - 100% 천연 무첨가: 어떠한 첨가물도 없이 100% 천연 재료로 만들어졌습니다.`,
    description: `
    뉴질랜드의 비옥한 초원에서 온 순수한 생 양 간 그대로를, 영양을 최대한 보존하기 위해 동결 건조하여 재밀봉 가능한 포장에 담았습니다. 이것이 전부입니다. 오직 순수함 그 자체죠! 인공적인 성분, 곡물, 첨가물, 색소, 방부제는 전혀 들어있지 않습니다.
    50g 간식 한 팩은 생 간 250g과 맞먹는 풍부한 영양을 제공하며, 냉장 보관이 필요 없어 더욱 편리합니다. 반려견은 자연 그대로의 맛에 푹 빠져들 것이고, 보호자님께서는 풍부한 미량 영양소로부터 얻는 기능적인 건강상의 이점에 만족하실 겁니다.
    모든 크기와 연령의 반려견을 위한 100% 천연 맛있는 훈련 간식입니다.

    저희 반려견용 양 간 간식은 수많은 이점을 제공합니다. 비타민 A, B12, D와 철분, 아연 등 필수 영양소가 풍부하게 함유되어 있어, 건강한 면역 기능과 시력 증진, 혈액 응고 보조, 그리고 튼튼한 뼈 형성에 도움을 줍니다.
    양 간은 건강한 근육 성장과 회복, 그리고 균형 잡힌 신진대사에 필수적인 고품질 단백질을 제공합니다. 높은 철분 함량은 빈혈 예방에 도움을 주어 에너지와 지구력을 높여줍니다. 비타민 B군은 소화를 돕고 영양소 흡수를 촉진하며, 건강한 장 환경을 유지하는 데 기여합니다. 비타민 A는 피부 건강을 증진시켜 윤기 나는 털을 가꾸는 데 도움을 줍니다. 또한, 특히 비타민 B12를 포함한 비타민 B군은 인지 기능을 지원하여 정신 건강에도 긍정적인 영향을 줄 수 있습니다.
    `,
    ingredient: `100% 뉴질랜드산 양 간
    * 본 제품에는 밀, 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    warnings: `[중요 안내] 이 천연 간식은 반려견의 주식 대용이 아닙니다. 간식으로만 사용하세요. 또한 사람이 먹는 용도가 아닙니다. 급여 시에는 항상 옆에서 지켜봐 주시기 바랍니다.`,
    image: 'Nutreats_Dog_SheepLiver.png',
  },
];

const categories = [
  { id: 1, path: 'cat', name: '고양이용', amount: 3 },
  { id: 2, path: 'dog', name: '개용', amount: 4 },
];

function generateSlug(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9가-힣]/g, '-') // 특수문자를 하이픈으로 변경
    .replace(/-+/g, '-') // 여러 하이픈을 하나로 합침
    .replace(/^-|-$/g, ''); // 앞뒤 하이픈 제거
}

// 기존 데이터에 슬러그 추가
const animal_products_with_slug = animal_products.map((product) => ({
  ...product,
  slug: product.slug || generateSlug(product.name),
}));

function getProductImagePath(fileName) {
  return `${IMAGE_BASE_PATH}${fileName}`;
}

export {
  animal_products_with_slug,
  categories,
  IMAGE_BASE_PATH,
  getProductImagePath,
};
